import PerfilForm from '../../components/perfiles/PerfilForm';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { usePerfilesStore } from '../../stores/perfiles/perfiles.store';
import type { ActualizarPerfilRequest } from '../../api-client/perfiles/perfiles.api';

const EditarPerfil = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: perfil,
    actualizar,
    cargarPorId,
    desactivar,
  } = usePerfilesStore();

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarPerfilRequest) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    // await activar(id);
  };

  return (
    <PerfilForm
      perfil={perfil}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarPerfil;
